export class CourrierActions {
  id: number;
  valableCourrierStatutAction: boolean;
  valableCourrierStatutActionArchivageMasse: boolean;
  description: string;
  utilisable: boolean;
}
